module.exports = __webpack_public_path__ + "static/media/notfound.36797a63.png";